import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEmployeeAttritionReady} from '../redux/teams'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'

import * as Helpers from '../../../common/helpers'

import DateTimeField from "react-bootstrap-datetimepicker";


//import TimePicker from 'react-time-picker'

import {WhatsAppGroup,AttritionReasons} from './DropDowns/index'

//var TimePicker = require('basic-react-timepicker');


function filterUnwantedData(employeeData) {
    let data = {}
    if (employeeData && employeeData.data && employeeData.data) {
        data = employeeData.data
    }

    let newData = {}
            newData.id = data.id ? data.id : ""
            newData.name = data.name ? data.name : ""
            newData.email = data.email ? data.email : ""
            newData.code = data.code ? data.code : ""
            newData.mobile = data.mobile ? data.mobile : ""
            newData.city_name="NA"
            newData.work_location_type=data.work_location_type ? data.work_location_type : "NA"
            newData.work_location="NA"

            if(data.city && data.city.name){
                newData.city_name=data.city.name
            }


             if(data.kitchen_work_location && data.kitchen_work_location.name && data.work_location_type==="Kitchen"){
                newData.work_location=data.kitchen_work_location.name
            }

            if(data.office_work_location && data.office_work_location.name && data.work_location_type!=="Kitchen"){
                newData.work_location=data.office_work_location.name
            }
    
    return newData
}


class AddEmployeeAttrition extends Component {

    constructor() {
        super()
        this.state = {
            
            bodyHeight: "0px",
            clearIcon:null,
            lwd:new Date(),
                   
            employeeData:{},
            
            selectedEmployeeId: "",
            whatsAppGroup:"",
            reasonId:"",
            remarks:"",
            attritionSource:"",
            attrition_reason_type:"MANAGER_ATTRITION",

            remarksErrorText: false,
            remarksErrorData: '',       

            reasonIdErrorText: false,
            reasonIdErrorData: '',

            whatsAppGroupErrorText: false,
            whatsAppGroupErrorData: '',
           
         }


        this.whatsAppGroupComponent = null
        this.whatsAppGroupSection = null

        this.reasonIdComponent = null
        this.reasonIdSection = null       

        this.remarksComponent = null
        this.remarksSection = null
    
    
    
       
    }

    componentWillMount() {




        this.isComponentStillMounted = true
        this.props.dispatch(addEmployeeAttritionReady(false))
        
        if(this.props.teams && this.props.teams.teamEmployeeSelectedId && this.props.teams.teamEmployeeSelectedId !== null){
            this.setState({subTitle: Constants.ADD_EMPLOYEE_ATTRITION})
            this.props.dispatch(headerDataUpdate(Constants.ADD_EMPLOYEE_ATTRITION)) 
            this.props.dispatch(subHeaderDataUpdate())
            this.setState({
                selectedEmployeeId: this.props.teams.teamEmployeeSelectedId,
                attritionSource:this.props.teams.attritionSource,
            });

            if(this.props.teams.attritionSource==="EmployeesList"){
                this.setState({
                    attrition_reason_type:"HR_ATTRITION" 
                });
            }
            this.getEmployeeViewById(this.props.teams.teamEmployeeSelectedId)
        }else{
            this.props.history.goBack()
        }
        
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
    }

    componentDidMount() {

        this.whatsAppGroupSection = ReactDOM.findDOMNode(this.refs.whatsAppGroupSection)
        this.reasonIdSection = ReactDOM.findDOMNode(this.refs.reasonIdSection)        
        this.remarksSection = ReactDOM.findDOMNode(this.refs.remarksSection)

    }

    updateDimensions = () => {
        if (window.innerWidth <= 767) {
            this.setState({
                bodyHeight: (window.innerHeight - 130) + "px",
            })
        } else {
            this.setState({
                bodyHeight: (window.innerHeight - 100) + "px",
            })
        }
    }

    mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    whatsAppGroupChange= (data) => {
            this.whatsAppGroupComponent.value=data.value
            this.setState({
                whatsAppGroup :data.value,
                whatsAppGroupErrorText: false,
                whatsAppGroupErrorData: ''
            })
            this.whatsAppGroupSection.className= this.whatsAppGroupSection.className.replace(" has-error", "")
        }





getEmployeeViewById = (id) => {
    apiService.getEmployeeViewById(id)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {

            if (responseData && responseData.data) {
                let filterData=filterUnwantedData(responseData)
                   
                    this.setState({
                        employeeData: filterData,
                        })
                    
                     this.props.dispatch(addEmployeeAttritionReady(true))
            

                }else{
                    this.props.dispatch(addEmployeeAttritionReady(true))
                    this.props.history.goBack()
                }

            }else{

                 this.props.dispatch(addEmployeeAttritionReady(true))
                 this.props.history.goBack()
             }

        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEmployeeAttritionReady(true))
        })
}


    onSaveClick = () => {
        this.props.dispatch(addEmployeeAttritionReady(false))
        let data ={}

        if(this.state.lwd==="" || this.state.lwd===undefined){
            this.dialog.show({
                            title: "Error",
                            body: "Please select valid last working date",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
            this.props.dispatch(addEmployeeAttritionReady(true))
            return
        } 

        data.last_working_day=this.state.lwd;

         let whatsAppGroupObject = this.mandateValidation("whatsAppGroup", Constants.FORM_SELECT)
            if (whatsAppGroupObject.status) {
                data.group_excluded = this.whatsAppGroupComponent.value
            } else {
                this.props.dispatch(addEmployeeAttritionReady(true))
                return
            }


         let reasonIdObject = this.mandateValidation("reasonId", Constants.FORM_SELECT)
            if (reasonIdObject.status) {
                if(this.state.attritionSource==="EmployeesList"){
                    data.hr_reason_id = this.reasonIdComponent.value
                }else{
                    data.manager_reason_id= this.reasonIdComponent.value
                }
            } else {
                this.props.dispatch(addEmployeeAttritionReady(true))
                return
            }

        let remarksObject = this.mandateValidation("remarks", Constants.FORM_INPUT)
            if (remarksObject.status) {
                if(this.state.attritionSource==="EmployeesList"){
                    data.hr_remarks = this.remarksComponent.value
                }else{
                     data.manager_remarks = this.remarksComponent.value
                }
            } else {
                this.props.dispatch(addEmployeeAttritionReady(true))
                return
            }

        let apiPayloadData=data

        apiService.addEmployeeAttrition(apiPayloadData,this.state.employeeData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEmployeeAttritionReady(true))
                        this.props.history.goBack()
                    } else {

                        this.props.dispatch(addEmployeeAttritionReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEmployeeAttritionReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
            


    }

   
    onCancelClick = () => {
        this.props.history.goBack()
    }


    lwdChange = (newDate) => {

        let lwd=Helpers.getDateFormatForUTC(parseInt(newDate,10));

        this.setState({
            lwd: lwd
        });
    }

    attritionReasonsChange= (data) => {
            this.reasonIdComponent.value=data.value
            this.setState({
                reasonId :data.value,
                reasonIdErrorText: false,
                reasonIdErrorData: ''
            })
            this.reasonIdSection.className= this.reasonIdSection.className.replace(" has-error", "")
        }

    
    render() {
        return (
            <div className="line-item-edit">

                 <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>


                <Dialog ref={el => this.dialog = el} />
                <section className="content">

                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>Add Attrition</h3>
                                </div>
                                <div className="form-horizontal">
                                        <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                            
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Name :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.code}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Email Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.email}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Mobile :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.mobile}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.city_name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Work Location :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.work_location}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <hr/>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                            <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Last Working Day *</label>
                                                            <div className="col-sm-9">
                                                                <DateTimeField mode="date" inputFormat="DD-MM-YYYY" dateTime={new Date(this.state.lwd)} onChange={this.lwdChange}/>
                                                            </div>
                                                    </div>
                                                </div>

                                            </div>


                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                  <div className="form-group" ref={el =>
                                                     this.whatsAppGroupSection = el}>
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Removed From WhatsApp Group *</label>
                                                     <div className="col-sm-9" ref={el =>
                                                     this.whatsAppGroupComponent = el}>
                                                        <WhatsAppGroup whatsAppGroupChange={this.whatsAppGroupChange} selectedValue={this.state.whatsAppGroup} />
                                                        <span className="help-block" style={{ display: this.state.whatsAppGroupErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                        {this.state.whatsAppGroupErrorData}
                                                        </span>
                                                     </div>
                                                  </div>
                                               </div>
                                               </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                               <div className="col-md-6 col-sm-12 col-xs-12">
                                                  <div className="form-group" ref={el =>
                                                     this.reasonIdSection = el}>
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason for Attrition *</label>
                                                     <div className="col-sm-9" ref={el =>
                                                                                     this.reasonIdComponent = el}>
                                                        <AttritionReasons type={this.state.attrition_reason_type} attritionReasonsChange={this.attritionReasonsChange} selectedValue={this.state.reasonId} />
                                                        <span className="help-block" style={{ display: this.state.reasonIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                        {this.state.reasonIdErrorData}
                                                        </span>
                                                     </div>
                                                  </div>
                                               </div>
                                            </div>

                                           


                                             <div className="col-md-12 col-sm-12 col-xs-12">
                                                   <div className="col-md-6 col-sm-12 col-xs-12">
                                                      <div className="form-group" ref={el =>
                                                         this.remarksSection = el}>
                                                         <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks *</label>
                                                         <div className="col-sm-9">
                                                             <textarea className="form-control" placeholder="Enter Remarks...." ref={el => this.remarksComponent = el}
                                                                        onChange={(e) => {e.preventDefault() 
                                                                        this.keyedInputChange("remarks")}} />
                                                            <span className="help-block" style={{ display: this.state.remarksErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                            </span>
                                                         </div>
                                                      </div>
                                                   </div>

                                                 </div>



                                        </div>

                                        <div className="box-footer">
                                            <button
                                                className="btn btn-default"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.onCancelClick()
                                                }}>
                                                Cancel
                                            </button>
                                            <button
                                                className="btn btn-info pull-right"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.onSaveClick()
                                                }}>
                                                Save Changes
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </section>
            </div>
        )
    }



    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        teams: state.teams,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEmployeeAttrition))


// WEBPACK FOOTER //
// ./src/modules/Teams/Components/AddEmployeeAttrition.js